// extracted by mini-css-extract-plugin
export var remove = "styles-module__remove___Ptczv";
export var add = "styles-module__add___W1mu2";